import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { RequestCategoryItem } from '../../types';
import { formatNumber, REQUEST_CATEGORY_LABELS } from '../../constants/nginx-sites';

interface RequestCategoryBreakdownProps {
  data: RequestCategoryItem[];
}

// Data visualization colors - not theme-adaptive
const CATEGORY_COLORS: Record<string, string> = {
  page: '#3b82f6',
  api: '#8b5cf6',
  static: '#6b7280',
  image: '#f59e0b',
  probe: '#ef4444',
  websocket: '#06b6d4',
  unknown: '#9ca3af',
};

export function RequestCategoryBreakdown({ data }: RequestCategoryBreakdownProps) {
  if (!data || data.length === 0) return null;

  const maxCount = Math.max(...data.map((d) => d.count));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Categorias de Requisição</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {data.map((item) => (
          <div key={item.category} className="space-y-1">
            <div className="flex items-center justify-between text-sm">
              <span>{REQUEST_CATEGORY_LABELS[item.category] || item.category}</span>
              <span className="text-muted-foreground">
                {formatNumber(item.count)} ({item.percentage.toFixed(1)}%)
              </span>
            </div>
            <div className="w-full bg-muted rounded-full h-2">
              <div
                className="h-2 rounded-full transition-all"
                style={{
                  width: `${(item.count / maxCount) * 100}%`,
                  backgroundColor: CATEGORY_COLORS[item.category] || '#9ca3af',
                }}
              />
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
